import React, {PureComponent} from 'react';
import {
    View,
    StyleSheet
} from 'react-native';
import {
    JDText,
    JDImage,
    JDTouchable,
    JDDialog
} from '@jdreact/jdreact-core-lib';
import { pt, px, mta } from '../../../common/utils';
// import { get, post } from '../../common/fetch';

class CouponDetail extends PureComponent {
    static defaultProps = {
        isShow: false,
        closeDialog: () => { },
        currentCoupon: {}
    }
    _closeDialog() {
        this.props.closeDialog();
    }
    render() {
        const { isShow, currentCoupon } = this.props;
        return (
            currentCoupon && <JDDialog dialogStyle={st.dialog}
                      show={isShow}
                      overlayClickable = {false}
                      onClose={() => this._closeDialog()}>
                <View style={[st.main]}>
                    <View style={{flexDirection: 'row',justifyContent: 'flex-end',paddingTop: pt(10)}}>
                        <JDTouchable onPress={() => this._closeDialog()}>
                            <JDImage style={st.close} source={img.coupon_close_icon} />
                        </JDTouchable>
                    </View>
                    <View style={[st.title]}><JDText style={[st.t_txt]}>{currentCoupon.activeOrderGoodsCouponDTO.couponName}</JDText></View>
                    {
                        currentCoupon.activeOrderGoodsCouponDTO.activeGoodsInstructionList.map((item, index) => {
                            return(
                                <View key={index}>
                                    <View style={{paddingBottom: pt(10)}}><JDText style={[st.item_t_txt]}>{item.title}</JDText></View>
                                    <View style={{paddingBottom: pt(18)}}><JDText style={[st.item_d_txt]}>{item.content}</JDText></View>
                                </View>
                            )
                        })
                    }
                    {/* <View style={{paddingBottom: pt(10)}}><JDText style={[st.item_t_txt]}>优惠券使用说明</JDText></View> */}
                    {/* <View style={{paddingBottom: pt(26)}}><JDText style={[st.item_d_txt]}>详情说明文案灵活运⽤用交互设计原则和理论，熟练掌握常⽤用的⽤用研⽅方法掌握基本的产品数据分析⽅方法能承担两个以上项⽬目并⾏行行能发现本质性问题并推动落地主导制定设计规范不不断学习，关注⾏行行业动态和设计趋势。能总结设计⽅方法和规律律跨部⻔门分享，有效辅导初级员⼯工。能总结设计⽅方法和规律律跨部⻔门分享，有效辅导初级员工工作。</JDText></View> */}
                </View>
            </JDDialog>
        )
    }
}
const img = {
    coupon_close_icon: require('../img/coupon_close_icon.png')
};
const st = StyleSheet.create({
    dialog: {
        width: '90.67%',
        borderRadius: pt(5)
    },
    main: {
        position: 'relative',
        paddingLeft: pt(18),
        paddingRight: pt(18),
        paddingBottom: pt(8)
    },
    title: {
        flexDirection: 'row',
        justifyContent: 'center',
        marginTop: pt(-2),
        paddingBottom: pt(23)
    },
    t_txt: {
        color: "#333",
        fontSize: pt(19)
    },
    item_t_txt: {
        color: "#666",
        fontSize: pt(16)
    },
    item_d_txt: {
        lineHeight: pt(20),
        color: "#666",
        fontSize: pt(13)
    },
    close: {
        width: pt(13),
        height: pt(13)
    }
});
export default CouponDetail;